/**
 * Collapsible cookie category panel for EU Cookie Compliance banner.
 */

/**
 * @param {Document|Element} [context]
 */
export function initZkCookieConsentDetails(context = document) {
  const toggles = context.querySelectorAll(
    '#sliding-popup .zk-cookie-consent .zk-cookie-consent__details-toggle',
  );

  toggles.forEach((toggle) => {
    if (toggle.dataset.zkCookieDetailsInit === '1') {
      return;
    }
    toggle.dataset.zkCookieDetailsInit = '1';

    const banner = toggle.closest('.zk-cookie-consent');
    const panel = banner?.querySelector('#eu-cookie-compliance-categories');
    if (!(banner instanceof HTMLElement) || !(panel instanceof HTMLElement)) {
      return;
    }

    const showLabel = toggle.dataset.showLabel || toggle.textContent?.trim() || '';
    const hideLabel = toggle.dataset.hideLabel || showLabel;

    const setOpen = (open) => {
      banner.classList.toggle('zk-cookie-consent--details-open', open);
      document.body.classList.toggle('zk-cookie-consent-details-expanded', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? hideLabel : showLabel;
      if (open) {
        panel.removeAttribute('hidden');
      }
      else {
        panel.setAttribute('hidden', '');
      }
    };

    setOpen(false);

    toggle.addEventListener('click', () => {
      setOpen(!banner.classList.contains('zk-cookie-consent--details-open'));
    });
  });
}

/**
 * One-shot body margin reset after eu_cookie_compliance slide (CSS handles position).
 */
function zkResetCookieBodyMargin() {
  document.body.style.setProperty('margin-top', '0', 'important');
}

export function registerZkCookieConsentDetails() {
  let pinScheduled = false;

  const stabilizePopup = () => {
    if (pinScheduled) {
      return;
    }
    pinScheduled = true;
    window.requestAnimationFrame(() => {
      pinScheduled = false;
      zkResetCookieBodyMargin();
      const popup = document.getElementById('sliding-popup');
      if (popup instanceof HTMLElement) {
        initZkCookieConsentDetails(popup);
      }
    });
  };

  if (typeof Drupal !== 'undefined' && Drupal.behaviors) {
    Drupal.behaviors.zkCookieConsentDetails = {
      attach(context) {
        initZkCookieConsentDetails(context);
        stabilizePopup();
      },
    };
  }

  // Watch only for the banner node — not the whole document tree.
  if (document.body instanceof HTMLElement && typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        if (record.type !== 'childList') {
          continue;
        }
        const addedPopup = [...record.addedNodes].some(
          (node) =>
            node instanceof HTMLElement &&
            (node.id === 'sliding-popup' || node.querySelector?.('#sliding-popup')),
        );
        if (addedPopup) {
          stabilizePopup();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true });
  }

  stabilizePopup();

  if (typeof jQuery !== 'undefined') {
    jQuery(document).on(
      'eu_cookie_compliance_popup_open eu_cookie_compliance_popup_close',
      stabilizePopup,
    );
  }
}
